import { Col } from 'reactstrap';
import copy from 'copy-to-clipboard';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PhoneNumber = ({ phoneNumber = '' }) => {
    const onClick = () => phoneNumber && clickPhoneNumber(phoneNumber);
    let colClasses = 'py-3 d-flex px-3 py-2';
    let spanClass = '';
    if (phoneNumber) {
        colClasses += ' hoverable';
        spanClass = 'underline-on-hover';
    }
    return (
        <Col
            lg={6}
            md={12}
            className={colClasses}
            onClick={onClick}
            title="Practice Phone">
            <span className={spanClass}>
                <FontAwesomeIcon
                    className="text-light op-6"
                    icon={faPhone}
                    size="lg"
                />
                &emsp;
                {formatPhoneNumber(phoneNumber)}
            </span>
            <span id="phoneText" className="text-light op-8"></span>
        </Col>
    );
};

const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '--';
    //Filter only numbers from the input
    let cleaned = ('' + phoneNumber).replace(/\D/g, '');
    //Check if the input is of correct
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        //Remove the matched extension code
        //Change this to format for any country code.
        let intlCode = match[1] ? '+1 ' : '';
        let parts = [intlCode, '(', match[2], ') ', match[3], '-', match[4]];
        return parts.join('');
    }
    return phoneNumber;
};

const clickPhoneNumber = (phoneNumber) => {
    copy((formatPhoneNumber(phoneNumber) || '')?.toUpperCase());
    var elem = document.getElementById(`phoneText`);
    elem.innerHTML = '&emsp;Copied!';
    setTimeout(() => {
        elem.innerHTML = '';
    }, 1000);
};

export default PhoneNumber;
